import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { GridColDef } from '@mui/x-data-grid-premium';
import { Table } from '../../components/Table';
import { fetchStatuses } from '../../constants/fetchStatuses';
import { fetchFundNavHistory } from '../../redux/modules/indexFund/indexFund.actions';
import { indexFundSelector } from '../../redux/modules/indexFund/indexFund.selectors';
import { round2Format } from '../../utils/number';

interface IndexFundNavHistoryTabProps {
  fundId: number;
}

export function IndexFundNavHistoryTab({ fundId }: IndexFundNavHistoryTabProps) {
  const columns = useRef<GridColDef[]>([
    { field: 'id', headerName: 'Id' },
    {
      field: 'dateTime',
      headerName: 'Date Time',
      type: 'dateTime',
      width: 200,
    },
    {
      field: 'nav',
      headerName: 'Nav',
      sortable: false,
      width: 120,
      valueFormatter: (params) => round2Format(params.value),
    },
    {
      field: 'originalNav',
      headerName: 'Original Nav',
      sortable: false,
      width: 120,
      valueFormatter: (params) => round2Format(params.value),
    },
    {
      field: 'fxRate',
      headerName: 'FX Rate',
      sortable: false,
      width: 120,
      valueFormatter: (params) => round2Format(params.value),
    },
    {
      field: 'updatedAt',
      headerName: 'Last Update',
      sortable: false,
      type: 'dateTime',
      width: 200,
    },
  ]);
  const { totalFundNavHistoryItems, fundNavHistoryItems, fetchFundNavHistoryStatus } = useSelector(indexFundSelector);

  return (
    <Table
      fetchItems={fetchFundNavHistory}
      fetchItemsCustomParams={{ indexFundId: fundId }}
      rows={fundNavHistoryItems}
      columns={columns.current}
      loading={fetchFundNavHistoryStatus === fetchStatuses.pending}
      rowCount={totalFundNavHistoryItems}
      initialColumnVisibilityModel={{ id: false }}
      initialSortModel={[{ field: 'dateTime', sort: 'desc' }]}
    />
  );
}
